import {ProcessVariableEdit} from "./ProcessVariableEdit";

export class ProcessVariablesEditorState {
    constructor(
        public processVariables: ProcessVariableEdit[] = [],
        public isDirty: boolean = false,
    ) { }
}
